import loadGoogleMapsApi from 'load-google-maps-api';

export default {

	init() {
		const maps = Array.from(document.querySelectorAll('.ga-map'));
		if (!maps.length) return;
		loadGoogleMapsApi({ key: gaApiKey }).then((googleMaps) => {
			maps.forEach((elm) => {
				const map = new googleMaps.Map(elm, {
					zoomControl: true,
					mapTypeControl: false,
					scaleControl: false,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
					center: {
						lat: parseFloat(elm.dataset.lat),
						lng: parseFloat(elm.dataset.lng),
					},
					zoom: parseInt(elm.dataset.zoom),
					styles: [
						{
							elementType: 'geometry',
							stylers: [
								{
									color: '#212121',
								},
							],
						},
						{
							elementType: 'labels.icon',
							stylers: [
								{
									visibility: 'off',
								},
							],
						},
						{
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#757575',
								},
							],
						},
						{
							elementType: 'labels.text.stroke',
							stylers: [
								{
									color: '#212121',
								},
							],
						},
						{
							featureType: 'administrative',
							elementType: 'geometry',
							stylers: [
								{
									color: '#757575',
								},
							],
						},
						{
							featureType: 'administrative.country',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#9e9e9e',
								},
							],
						},
						{
							featureType: 'administrative.land_parcel',
							stylers: [
								{
									visibility: 'off',
								},
							],
						},
						{
							featureType: 'administrative.locality',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#bdbdbd',
								},
							],
						},
						{
							featureType: 'poi',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#757575',
								},
							],
						},
						{
							featureType: 'poi.park',
							elementType: 'geometry',
							stylers: [
								{
									color: '#181818',
								},
							],
						},
						{
							featureType: 'poi.park',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#616161',
								},
							],
						},
						{
							featureType: 'poi.park',
							elementType: 'labels.text.stroke',
							stylers: [
								{
									color: '#1b1b1b',
								},
							],
						},
						{
							featureType: 'road',
							elementType: 'geometry.fill',
							stylers: [
								{
									color: '#2c2c2c',
								},
							],
						},
						{
							featureType: 'road',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#8a8a8a',
								},
							],
						},
						{
							featureType: 'road.arterial',
							elementType: 'geometry',
							stylers: [
								{
									color: '#373737',
								},
							],
						},
						{
							featureType: 'road.highway',
							elementType: 'geometry',
							stylers: [
								{
									color: '#3c3c3c',
								},
							],
						},
						{
							featureType: 'road.highway.controlled_access',
							elementType: 'geometry',
							stylers: [
								{
									color: '#4e4e4e',
								},
							],
						},
						{
							featureType: 'road.local',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#616161',
								},
							],
						},
						{
							featureType: 'transit',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#757575',
								},
							],
						},
						{
							featureType: 'water',
							elementType: 'geometry',
							stylers: [
								{
									color: '#000000',
								},
							],
						},
						{
							featureType: 'water',
							elementType: 'labels.text.fill',
							stylers: [
								{
									color: '#3d3d3d',
								},
							],
						},
					],
				});

				// Display the marker
				const marker = new googleMaps.Marker({
					position: {
						lat: parseFloat(elm.dataset.lat),
						lng: parseFloat(elm.dataset.lng),
					},
					icon: {
						path: 'M6.016 9.698a2.365 2.365 0 0 0 1.732.728c.67 0 1.248-.243 1.733-.728a2.365 2.365 0 0 0 .727-1.732c0-.67-.242-1.247-.727-1.732a2.365 2.365 0 0 0-1.733-.728c-.67 0-1.247.242-1.732.728a2.365 2.365 0 0 0-.727 1.732c0 .67.242 1.247.727 1.732zM2.276 2.33C3.793.777 5.636 0 7.803 0c2.167 0 4.019.768 5.554 2.303 1.536 1.535 2.303 3.387 2.303 5.554 0 1.698-.542 3.27-1.625 4.715l-4.877 8.507a.631.631 0 0 0-.109.162.624.624 0 0 1-.108.163l-.054.108v-.054c-.289.362-.65.542-1.084.542-.47 0-.849-.199-1.137-.596-.036 0-.054-.018-.054-.054 0-.036-.018-.073-.054-.109L1.57 12.517C.524 11.108 0 9.555 0 7.857 0 5.69.759 3.847 2.276 2.33z',
						fillColor: '#FFF',
						fillOpacity: 1,
						scale: 2,
						strokeColor: '#FFF',
						anchor: new googleMaps.Point(7, 22),
					},
					map,
				});
			});
		}).catch((error) => {
			console.error(error);
		});
	},

};
